
import './index.css';

function SuccessFactors({ handle, meta, domain, parentId, updateDomain }) {

  const emptyFactor = () => {
    return { name: '', status: 'not_started', targetValue: '', currentValue: '' };
  };

  const updateFactor = (index, field, value) => {
    updateDomain((prev) => {
      const next = [...prev.successFactors];
      next[index] = { ...next[index], [field]: value };
      return { ...prev, successFactors: next };
    });
  };

  const addFactor = () => {
    updateDomain((prev) => ({
      ...prev,
      successFactors: [...prev.successFactors, emptyFactor()],
    }));
  };

  const removeFactor = (index) => {
    updateDomain((prev) => {
      const next = prev.successFactors.filter((_, i) => i !== index);
      return { ...prev, successFactors: next.length ? next : [emptyFactor()] };
    });
  };

  return (
    <section className="card-subsection">
      <div className="row-between">
        <h3 className="section-title">Measurable Success Factors</h3>
        <button className="button-secondary" onClick={addFactor} type="button">
          Add Factor
        </button>
      </div>
      <div className="stack-sm">
        {domain.successFactors?.map((factor, index) => (
          <div className="inline-form-card" key={factor.id || `new-${index}`}>
            <input
              placeholder="Factor name"
              value={factor.name}
              onChange={(e) => updateFactor(index, 'name', e.target.value)}
            />
            <select value={factor.status} onChange={(e) => updateFactor(index, 'status', e.target.value)}>
              <option value="not_started">Not Started</option>
              <option value="on_track">On Track</option>
              <option value="at_risk">At Risk</option>
              <option value="met">Met</option>
              <option value="missed">Missed</option>
            </select>
            <input
              type="number"
              step="0.01"
              placeholder="Target"
              value={factor.targetValue}
              onChange={(e) => updateFactor(index, 'targetValue', e.target.value)}
            />
            <input
              type="number"
              step="0.01"
              placeholder="Current"
              value={factor.currentValue}
              onChange={(e) => updateFactor(index, 'currentValue', e.target.value)}
            />
            <button className="button-danger" onClick={() => removeFactor(index)} type="button">
              Remove
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SuccessFactors;